import React from 'react';

import styles from './tagsFormStyles';

import TagsFormGroup from './TagsFormGroup/tagsFormGroup';
import TagsFormSuggestContainer from 'buyside/components/container/FundProfileShow/TagsFormSuggestContainer';

const { employerProfileTagGroups } = require('buyside/util/constantsFromRails.json');

const TagsForm = ({ values: { fundProfile } }) => {
  return (
    <div>
      <div className={styles.tagsFormGroups}>
        {employerProfileTagGroups.map((tagGroup, idx) => {
          const numSelected = tagGroup.subgroups.reduce(
            (acc, subgroup) =>
              acc + subgroup.tags.filter(({ name }) => fundProfile.tagNames.includes(name)).length,
            0
          );
          return <TagsFormGroup key={idx} tagGroup={tagGroup} numSelected={numSelected} />;
        })}
      </div>
      <TagsFormSuggestContainer employerProfileId={fundProfile.id} />
    </div>
  );
};

export default TagsForm;
